import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import Feature from 'front/components/Feature/Feature.js'
import BaseView from 'front/components/BaseView/BaseView.js'

import './FeatureList.css'
import template from './FeatureList.jinja'


var FeatureList = BaseView.extend({
    el: '.FeatureList',

    initialize () {
        this.views = _.map(this.$el.find('.Feature'), (el) => {
            return new Feature({
                el: $(el),
                parent: this
            })
        })

        this.state = new Backbone.Model({
            activeFeature: null
        })

        this.on('Feature-toggled', this.toggle)
    },

    toggle(newFeature) {
        let activeFeature = this.state.get('activeFeature')

        if (activeFeature) {
            activeFeature.deactivate()
        }

        if (activeFeature !== newFeature) {
            this.state.set('activeFeature', newFeature)
            newFeature.activate()
        } else {
            this.state.set('activeFeature', null)
        }
    }
})

export default FeatureList


// WEBPACK FOOTER //
// ./assets/app/front/components/FeatureList/FeatureList.js